import React, { useCallback } from "react";
import SearchGroup from "../SearchGroup";
import { useDispatch, useSelector } from "react-redux";
import { getSearchValue } from "../../store/recipesReducer/recipesSelectors";
import { getRecipesData } from "../../store/recipesReducer/recipesActions";
import { clearSearch, setValue } from "../../store/recipesReducer";

export const RecipesPagesSearch = ({ pageName }) => {
  const searchValue = useSelector(getSearchValue);
  const dispatch = useDispatch();

  const onSubmit = useCallback((e) => {
    e.preventDefault();
    dispatch(getRecipesData({ pageName }));
  }, []);

  const handleResetButton = useCallback(() => {
    dispatch(clearSearch());
    dispatch(getRecipesData({ pageName }));
  }, []);

  const onChange = useCallback((e) => {
    dispatch(setValue(e.target.value));
  });

  return (
    <SearchGroup onSubmit={onSubmit} handleResetButton={handleResetButton} value={searchValue} onChange={onChange} />
  );
};
